import { hotSearchTerms } from '@/mocks/homeData';

export default function HotSearchBar() {
  return (
    <div className="bg-primary-500 overflow-hidden">
      <div className="flex items-center h-11 md:h-12">
        {/* Fixed Label */}
        <div className="flex-shrink-0 flex items-center gap-2 px-4 md:px-6 bg-primary-600 h-full">
          <i className="ri-fire-line text-white text-base animate-pulse"></i>
          <span className="text-white font-bold text-xs md:text-sm whitespace-nowrap">实时热搜</span>
        </div>

        {/* Scrolling Content */}
        <div className="flex-1 overflow-hidden relative">
          <div className="flex animate-marquee whitespace-nowrap">
            {[...hotSearchTerms, ...hotSearchTerms].map((term, i) => (
              <span
                key={`${term}-${i}`}
                className="inline-flex items-center text-white/90 text-xs md:text-sm font-medium px-5"
              >
                {i < hotSearchTerms.length && (
                  <span className="text-accent-300 font-bold mr-1.5">{i + 1}</span>
                )}
                <span>{term}</span>
              </span>
            ))}
          </div>
        </div>

        {/* More Button */}
        <div className="flex-shrink-0 flex items-center px-4 md:px-6 bg-primary-600 h-full">
          <a
            href="#"
            className="text-white/80 hover:text-white text-xs font-medium whitespace-nowrap transition-colors cursor-pointer"
          >
            更多热搜 <i className="ri-arrow-right-s-line"></i>
          </a>
        </div>
      </div>

      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 30s linear infinite;
        }
        .animate-marquee:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
}